import { useLanguage } from "../i18n/LanguageContext";
import { useMeta } from "../hooks/useMeta";
import { MaskedLines, Reveal } from "../components/motion";
import { PButton } from "../components/forms";

export default function ThankYou() {
  const { t } = useLanguage();
  useMeta(`${t.thanks.title.join(" ")} — PILATES ON.`, t.thanks.text);

  return (
    <div
      data-testid="thankyou-page"
      className="flex min-h-[85vh] flex-col items-start justify-center px-6 md:px-12 lg:px-20"
    >
      <div className="mx-auto w-full max-w-[1400px]">
        <Reveal y={14}>
          <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-[#C5A059]">
            Pilates On.
          </p>
        </Reveal>
        <h1
          data-testid="thankyou-title"
          className="font-serif text-6xl font-light leading-[1.0] tracking-tight text-[#1C1C1A] md:text-8xl"
        >
          <MaskedLines lines={t.thanks.title} mount delay={0.15} />
        </h1>
        <Reveal delay={0.5}>
          <p data-testid="thankyou-text" className="mt-8 max-w-md text-lg font-light leading-relaxed text-[#66625A]">
            {t.thanks.text}
          </p>
          <div className="mt-12">
            <PButton to="/" variant="solid" data-testid="thankyou-home-button">
              {t.thanks.home}
            </PButton>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
